import { generateKeys, generateLocalization } from '../utils';
export const callDirection = generateKeys({
    incoming: {
        value: 'incoming',
        label: 'Incoming call',
    },
    outgoing: {
        value: 'outgoing',
        label: 'Outgoing call',
    },
});
export const callTagCategories = generateKeys({
    generalInquiries: {
        value: 'generalInquiries',
        label: 'General Inquiries',
    },
    kyc: {
        value: 'kyc',
        label: 'KYC',
    },
    funding: {
        value: 'funding',
        label: 'Funding',
    },
    trading: {
        value: 'trading',
        label: 'Trading',
    },
    technicalIssues: {
        value: 'technicalIssues',
        label: 'Technical Issues',
    },
    accountClosure: {
        value: 'accountClosure',
        label: 'Account Closure',
    },
    product: {
        value: 'product',
        label: 'Product',
    },
    mobileAppIssues: {
        value: 'mobileAppIssues',
        label: 'Mobile App Issues',
    },
});
export const callQuestions = generateLocalization('callQuestions', generateKeys({
    satisfaction: {
        label: 'Please rate the quality of the customer service you received today',
        type: 'rating',
        localization: { id: '', defaultMessage: '' },
    },
    communication: {
        label: 'Was the Agent polite and communicated effectively? ',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    issue: {
        label: 'Have we helped resolve the issue you have encountered?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    topUp: {
        label: 'Have we topped-up your demo account balance as per your request?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    leverage: {
        label: 'Have we changed your leverage as per your request?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    license: {
        label: 'Are you satisfied with the information provided regarding BDSwiss License and Regulation?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    login: {
        label: 'Have we helped with your login issue?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    liquidity: {
        label: 'Are you satisfied with the information provided regarding BDSwiss Liquidity Provider?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    dashboard: {
        label: 'Have we helped you through the Dashboard navigation?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    deposit: {
        label: 'Have we helped with your deposit inquiry?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    withdrawal: {
        label: 'Have we helped with your withdrawal inquiry?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    accountTypes: {
        label: 'Have we answered all your questions about our account types?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    swapAccounts: {
        label: 'Have we answered your questions about the Swap Free Account?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    request: {
        label: 'Has the Agent answered your request efficiently?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    accountVerification: {
        label: 'Have we helped with the required documents for your account verification?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    corporateAccountOpening: {
        label: 'Have we helped with the documents required for Corporate account opening?',
        type: 'yesNo',
        localization: { id: '', defaultMessage: '' },
    },
    relevance: {
        label: 'In this survey, have we covered everything you have discussed on the call?',
        type: 'rating',
        localization: { id: '', defaultMessage: '' },
    },
    comments: {
        label: 'Do you have any additional comments about your experience today?',
        type: 'text',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const callTags = generateKeys({
    topUpDemoBalance: {
        value: 'topUpDemoBalance',
        label: 'Top-Up Demo Balance',
        category: callTagCategories.generalInquiries.value,
        questions: [callQuestions.topUp.key],
    },
    changeOfLeverageHigher: {
        value: 'changeOfLeverageHigher',
        label: 'Change of Leverage - Higher',
        category: callTagCategories.generalInquiries.value,
        questions: [callQuestions.leverage.key],
    },
    changeOfLeverageLower: {
        value: 'changeOfLeverageLower',
        label: 'Change of Leverage - Lower',
        category: callTagCategories.generalInquiries.value,
        questions: [callQuestions.leverage.key],
    },
    licenceRegulation: {
        value: 'licenceRegulation',
        label: 'Licence & Regulation',
        category: callTagCategories.generalInquiries.value,
        questions: [callQuestions.license.key],
    },
    negativeBalanceCorrection: {
        value: 'negativeBalanceCorrection',
        label: 'Negative Balance Correction',
        category: callTagCategories.generalInquiries.value,
        questions: [callQuestions.request.key],
    },
    passwordReset: {
        value: 'passwordReset',
        label: 'Password Reset',
        category: callTagCategories.generalInquiries.value,
        questions: [callQuestions.request.key],
    },
    investorsPassword: {
        value: 'investorsPassword',
        label: 'Investor\'s Password',
        category: callTagCategories.generalInquiries.value,
        questions: [callQuestions.request.key],
    },
    unableToLogin: {
        value: 'unableToLogin',
        label: 'Unable to login',
        category: callTagCategories.generalInquiries.value,
        questions: [callQuestions.issue.key],
    },
    whoIsYourLiquidityProvider: {
        value: 'whoIsYourLiquidityProvider',
        label: 'Who is your Liquidity Provider',
        category: callTagCategories.generalInquiries.value,
        questions: [callQuestions.liquidity.key],
    },
    changeOfEntityGeneralInquiries: {
        value: 'changeOfEntityGeneralInquiries',
        label: 'Change of Entity',
        category: callTagCategories.generalInquiries.value,
        questions: [callQuestions.request.key],
    },
    dashboardNavigation: {
        value: 'dashboardNavigation',
        label: 'Dashboard Navigation',
        category: callTagCategories.generalInquiries.value,
        questions: [callQuestions.dashboard.key],
    },
    suggestions: {
        value: 'suggestions',
        label: 'Suggestions',
        category: callTagCategories.generalInquiries.value,
    },
    otherGeneralInquiries: {
        value: 'otherGeneralInquiries',
        label: 'Other',
        category: callTagCategories.generalInquiries.value,
    },
    accountVerificationRequiredDocuments: {
        value: 'accountVerificationRequiredDocuments',
        label: 'Account Verification - Required Documents',
        category: callTagCategories.kyc.value,
        questions: [callQuestions.accountVerification.key],
    },
    accountVerificationMissingDocuments: {
        value: 'accountVerificationMissingDocuments',
        label: 'Account Verification - Missing Documents',
        category: callTagCategories.kyc.value,
        questions: [callQuestions.accountVerification.key],
    },
    accountVerificationExpiredDocuments: {
        value: 'accountVerificationExpiredDocuments',
        label: 'Account Verification - Expired Documents',
        category: callTagCategories.kyc.value,
        questions: [callQuestions.accountVerification.key],
    },
    corporateAccountRequiredDocuments: {
        value: 'corporateAccountRequiredDocuments',
        label: 'Corporate Account - Required Documents',
        category: callTagCategories.kyc.value,
        questions: [callQuestions.corporateAccountOpening.key],
    },
    corporateAccountMissingDocuments: {
        value: 'corporateAccountMissingDocuments',
        label: 'Corporate Account - Missing Documents',
        category: callTagCategories.kyc.value,
        questions: [callQuestions.corporateAccountOpening.key],
    },
    corporateAccountExpiredDocument: {
        value: 'corporateAccountExpiredDocument',
        label: 'Corporate Account - Expired Document',
        category: callTagCategories.kyc.value,
        questions: [callQuestions.corporateAccountOpening.key],
    },
    verificationTime: {
        value: 'verificationTime',
        label: 'Verification Time',
        category: callTagCategories.kyc.value,
        questions: [callQuestions.request.key],
    },
    updateChangeProfileDetails: {
        value: 'updateChangeProfileDetails',
        label: 'Update/Change Profile Details',
        category: callTagCategories.kyc.value,
        questions: [callQuestions.request.key],
    },
    howToUploadMyDocuments: {
        value: 'howToUploadMyDocuments',
        label: 'How to Upload my Documents',
        category: callTagCategories.kyc.value,
        questions: [callQuestions.request.key],
    },
    verificationGracePeriodCysec15DaysSinceFirstDepositDate: {
        value: 'verificationGracePeriodCysec15DaysSinceFirstDepositDate',
        label: 'Verification Grace Period - CYSEC -15 Days since first deposit date',
        category: callTagCategories.kyc.value,
        questions: [callQuestions.request.key],
    },
    verificationGracePeriodFsc30DaysSinceFirstDepositDate: {
        value: 'verificationGracePeriodFsc30DaysSinceFirstDepositDate',
        label: 'Verification Grace Period - FSC - 30 Days since first deposit date',
        category: callTagCategories.kyc.value,
        questions: [callQuestions.request.key],
    },
    verificationGracePeriodLimitDepositsBelow2000EurUsdGbp: {
        value: 'verificationGracePeriodLimitDepositsBelow2000EurUsdGbp',
        label: 'Verification Grace Period Limit - Deposits below 2,000(EUR/USD/GBP)',
        category: callTagCategories.kyc.value,
        questions: [callQuestions.request.key],
    },
    changeOfPersonalDetailsIntoAThirdParty: {
        value: 'changeOfPersonalDetailsIntoAThirdParty',
        label: 'Change of Personal Details into a Third Party',
        category: callTagCategories.kyc.value,
        questions: [callQuestions.request.key],
    },
    otherKyc: {
        value: 'otherKyc',
        label: 'Other',
        category: callTagCategories.kyc.value,
    },
    depositFailedDeposit: {
        value: 'depositFailedDeposit',
        label: 'Deposit - Failed Deposit',
        category: callTagCategories.funding.value,
        questions: [callQuestions.deposit.key],
    },
    depositHeldDeposit: {
        value: 'depositHeldDeposit',
        label: 'Deposit - Held Deposit',
        category: callTagCategories.funding.value,
        questions: [callQuestions.deposit.key],
    },
    depositDepositFees: {
        value: 'depositDepositFees',
        label: 'Deposit - Deposit Fees',
        category: callTagCategories.funding.value,
        questions: [callQuestions.deposit.key],
    },
    withdrawalPendingWithdrawal: {
        value: 'withdrawalPendingWithdrawal',
        label: 'Withdrawal - Pending Withdrawal',
        category: callTagCategories.funding.value,
        questions: [callQuestions.withdrawal.key],
    },
    withdrawalRejectedWithdrawal: {
        value: 'withdrawalRejectedWithdrawal',
        label: 'Withdrawal - Rejected Withdrawal',
        category: callTagCategories.funding.value,
        questions: [callQuestions.withdrawal.key],
    },
    withdrawalWithdrawalFees: {
        value: 'withdrawalWithdrawalFees',
        label: 'Withdrawal - Withdrawal Fees',
        category: callTagCategories.funding.value,
        questions: [callQuestions.withdrawal.key],
    },
    withdrawalPendingDocuments: {
        value: 'withdrawalPendingDocuments',
        label: 'Withdrawal - Pending Documents',
        category: callTagCategories.funding.value,
        questions: [callQuestions.withdrawal.key],
    },
    withdrawalEnableWithdrawalOption: {
        value: 'withdrawalEnableWithdrawalOption',
        label: 'Withdrawal - Enable Withdrawal Option',
        category: callTagCategories.funding.value,
        questions: [callQuestions.withdrawal.key],
    },
    withdrawalIDidNotReceiveMyFunds: {
        value: 'withdrawalIDidNotReceiveMyFunds',
        label: 'Withdrawal - I did not receive my funds',
        category: callTagCategories.funding.value,
        questions: [callQuestions.withdrawal.key],
    },
    howToPlaceAWithdrawal: {
        value: 'howToPlaceAWithdrawal',
        label: 'How to place a withdrawal',
        category: callTagCategories.funding.value,
        questions: [callQuestions.request.key],
    },
    cardExpirationReplacement: {
        value: 'cardExpirationReplacement',
        label: 'Card Expiration/Replacement',
        category: callTagCategories.funding.value,
        questions: [callQuestions.request.key],
    },
    internalTransferResolved: {
        value: 'internalTransferResolved',
        label: 'Internal Transfer - Resolved',
        category: callTagCategories.funding.value,
        questions: [callQuestions.request.key],
    },
    otherFunding: {
        value: 'otherFunding',
        label: 'Other',
        category: callTagCategories.funding.value,
    },
    positionsBeingStoppedOut: {
        value: 'positionsBeingStoppedOut',
        label: 'Positions being Stopped-Out',
        category: callTagCategories.trading.value,
        questions: [callQuestions.request.key],
    },
    stopLoss: {
        value: 'stopLoss',
        label: 'Stop-loss',
        category: callTagCategories.trading.value,
        questions: [callQuestions.request.key],
    },
    trailingStop: {
        value: 'trailingStop',
        label: 'Trailing Stop',
        category: callTagCategories.trading.value,
        questions: [callQuestions.request.key],
    },
    takeProfit: {
        value: 'takeProfit',
        label: 'Take-profit',
        category: callTagCategories.trading.value,
        questions: [callQuestions.request.key],
    },
    margin: {
        value: 'margin',
        label: 'Margin',
        category: callTagCategories.trading.value,
        questions: [callQuestions.request.key],
    },
    fundamentalAnnouncements: {
        value: 'fundamentalAnnouncements',
        label: 'Fundamental Announcements',
        category: callTagCategories.trading.value,
        questions: [callQuestions.request.key],
    },
    slippageSpreadWidening: {
        value: 'slippageSpreadWidening',
        label: 'Slippage - Spread Widening',
        category: callTagCategories.trading.value,
        questions: [callQuestions.request.key],
    },
    gap: {
        value: 'gap',
        label: 'Gap',
        category: callTagCategories.trading.value,
        questions: [callQuestions.request.key],
    },
    tradingIndicators: {
        value: 'tradingIndicators',
        label: 'Trading Indicators',
        category: callTagCategories.trading.value,
        questions: [callQuestions.request.key],
    },
    howToOpenClosePositions: {
        value: 'howToOpenClosePositions',
        label: 'How to open/close positions',
        category: callTagCategories.trading.value,
        questions: [callQuestions.request.key],
    },
    pendingOrders: {
        value: 'pendingOrders',
        label: 'Pending Orders',
        category: callTagCategories.trading.value,
        questions: [callQuestions.request.key],
    },
    spreads: {
        value: 'spreads',
        label: 'Spreads',
        category: callTagCategories.trading.value,
        questions: [callQuestions.request.key],
    },
    otherTrading: {
        value: 'otherTrading',
        label: 'Other',
        category: callTagCategories.trading.value,
    },
    disabledAssets: {
        value: 'disabledAssets',
        label: 'Disabled Assets',
        category: callTagCategories.technicalIssues.value,
        questions: [callQuestions.request.key],
    },
    delayOnExecution: {
        value: 'delayOnExecution',
        label: 'Delay on Execution',
        category: callTagCategories.technicalIssues.value,
        questions: [callQuestions.request.key],
    },
    myTakeProfitDidNotTrigger: {
        value: 'myTakeProfitDidNotTrigger',
        label: 'My Take Profit did not trigger',
        category: callTagCategories.technicalIssues.value,
        questions: [callQuestions.request.key],
    },
    dataNotLoading: {
        value: 'dataNotLoading',
        label: 'Data not loading',
        category: callTagCategories.technicalIssues.value,
        questions: [callQuestions.request.key],
    },
    platformIsFrozen: {
        value: 'platformIsFrozen',
        label: 'Platform is frozen',
        category: callTagCategories.technicalIssues.value,
        questions: [callQuestions.request.key],
    },
    issueWithServer: {
        value: 'issueWithServer',
        label: 'Issue with server',
        category: callTagCategories.technicalIssues.value,
        questions: [callQuestions.request.key],
    },
    otherTechnicalIssues: {
        value: 'otherTechnicalIssues',
        label: 'Other',
        category: callTagCategories.technicalIssues.value,
    },
    registeredUnderTheWrongIbAffiliateLink: {
        value: 'registeredUnderTheWrongIbAffiliateLink',
        label: 'Registered under the wrong IB/Affiliate link',
        category: callTagCategories.accountClosure.value,
        questions: [callQuestions.request.key],
    },
    duplicateAccount: {
        value: 'duplicateAccount',
        label: 'Duplicate account',
        category: callTagCategories.accountClosure.value,
        questions: [callQuestions.request.key],
    },
    iDontWantToTradeAnymore: {
        value: 'iDontWantToTradeAnymore',
        label: 'I don’t want to trade anymore',
        category: callTagCategories.accountClosure.value,
        questions: [callQuestions.request.key],
    },
    changeOfEntityAccountClosure: {
        value: 'changeOfEntityAccountClosure',
        label: 'Change of Entity',
        category: callTagCategories.accountClosure.value,
        questions: [callQuestions.request.key],
    },
    otherAccountClosure: {
        value: 'otherAccountClosure',
        label: 'Other',
        category: callTagCategories.accountClosure.value,
    },
    accountTypes: {
        value: 'accountTypes',
        label: 'Account Types',
        category: callTagCategories.product.value,
        questions: [callQuestions.request.key],
    },
    tradingConditions: {
        value: 'tradingConditions',
        label: 'Trading Conditions',
        category: callTagCategories.product.value,
        questions: [callQuestions.request.key],
    },
    availableAssets: {
        value: 'availableAssets',
        label: 'Available Assets',
        category: callTagCategories.product.value,
        questions: [callQuestions.request.key],
    },
    speakWithAnExpert: {
        value: 'speakWithAnExpert',
        label: 'Speak with an Expert',
        category: callTagCategories.product.value,
        questions: [callQuestions.request.key],
    },
    swapFreeAccount: {
        value: 'swapFreeAccount',
        label: 'Swap Free Account',
        category: callTagCategories.product.value,
        questions: [callQuestions.request.key],
    },
    becomeAPartner: {
        value: 'becomeAPartner',
        label: 'Become a Partner',
        category: callTagCategories.product.value,
        questions: [callQuestions.request.key],
    },
    webinars: {
        value: 'webinars',
        label: 'Webinars',
        category: callTagCategories.product.value,
        questions: [callQuestions.request.key],
    },
    trainingMaterialEducation: {
        value: 'trainingMaterialEducation',
        label: 'Training Material/Education',
        category: callTagCategories.product.value,
        questions: [callQuestions.request.key],
    },
    platformsMt45WebtraderMobileApp: {
        value: 'platformsMt45WebtraderMobileApp',
        label: 'Platforms(MT4/5, Webtrader, Mobile App)',
        category: callTagCategories.product.value,
        questions: [callQuestions.request.key],
    },
    autochartist: {
        value: 'autochartist',
        label: 'Autochartist',
        category: callTagCategories.product.value,
        questions: [callQuestions.request.key],
    },
    copyTrading: {
        value: 'copyTrading',
        label: 'Copy Trading',
        category: callTagCategories.product.value,
        questions: [callQuestions.request.key],
    },
    otherProduct: {
        value: 'otherProduct',
        label: 'Other',
        category: callTagCategories.product.value,
    },
    unableToOpenCloseModifyPositions: {
        value: 'unableToOpenCloseModifyPositions',
        label: 'Unable to open/close/modify positions',
        category: callTagCategories.mobileAppIssues.value,
        questions: [callQuestions.issue.key],
    },
    unableToSeeTheCorrectBalance: {
        value: 'unableToSeeTheCorrectBalance',
        label: 'Unable to see the correct balance',
        category: callTagCategories.mobileAppIssues.value,
        questions: [callQuestions.issue.key],
    },
    chartsAreNotLoading: {
        value: 'chartsAreNotLoading',
        label: 'Charts are not loading',
        category: callTagCategories.mobileAppIssues.value,
        questions: [callQuestions.issue.key],
    },
    otherMobileAppIssues: {
        value: 'otherMobileAppIssues',
        label: 'Other',
        category: callTagCategories.mobileAppIssues.value,
        questions: [callQuestions.issue.key],
    },
});
export const callAnswers = generateLocalization('callAnswers', generateKeys({
    no: {
        label: 'No',
        value: 20,
        localization: { id: '', defaultMessage: '' },
    },
    yes: {
        label: 'Yes',
        value: 100,
        localization: { id: '', defaultMessage: '' },
    },
    terrible: {
        label: 'Terrible',
        value: 20,
        localization: { id: '', defaultMessage: '' },
    },
    poor: {
        label: 'Poor',
        value: 40,
        localization: { id: '', defaultMessage: '' },
    },
    ok: {
        label: 'Ok',
        value: 60,
        localization: { id: '', defaultMessage: '' },
    },
    good: {
        label: 'Good',
        value: 80,
        localization: { id: '', defaultMessage: '' },
    },
    great: {
        label: 'Great',
        value: 100,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const callRelatedQuestions = generateLocalization('callRelatedQuestions', generateKeys({
    badFeedback: {
        label: 'We are sorry you were not satisfied with your service today. What would help improve this experience?',
        localization: { id: '', defaultMessage: '' },
    },
    goodFeedback: {
        label: 'Do you have any additional comments about your experience today?',
        localization: { id: '', defaultMessage: '' },
    },
}));
